import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/Endpoint";
import usePatchHook from "../../customHooks/usePatchHook";
import ServiceTypeIcon from "../../Icons/ServiceTypeIcon";
const ServiceTypeListComponent = loadable(
  () => import("../../components/ServiceType/ServiceTypeList")
);

const ServiceTypeList = () => {
  const { mutateAsync: patchStatus, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["service-type"],
    navigateURL: "",
  });

  const handleIsActive = async (value: boolean, id: any) => {
 
  const payload = {
    is_active: value
  };
  const url = `${APIS.SERVICE_TYPE}${id}/`;
  const formData = payload
  try {
    await patchStatus({ url, formData });

  } catch (e) {
    console.log(e)
  }
};





  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <ServiceTypeIcon/>
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Service Type
        </span>
      </div>
      <ServiceTypeListComponent
      handleIsActive={handleIsActive}
       />
    </>
  );
};

export default ServiceTypeList;
